var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeiqiang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4018_3774)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4018_3774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5H8V3.5H0.5V0.5Z",
    fill: "#FE624D",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6.5H8V9.5H0.5V6.5Z",
    fill: "#FE624D",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12.5H8V15.5H0.5V12.5Z",
    fill: "#FE624D",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 3.5,
    width: 7,
    height: 3,
    fill: "#FE624D",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 9.5,
    width: 7,
    height: 3,
    fill: "#FE624D",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 3.5,
    width: 4,
    height: 3,
    fill: "#FE624D",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 9.5,
    width: 4,
    height: 3,
    fill: "#FE624D",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 3.5,
    width: 4,
    height: 3,
    fill: "#FE624D",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 9.5,
    width: 4,
    height: 3,
    fill: "#FE624D",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 0.5H15.5V3.5H8V0.5Z",
    fill: "#FE624D",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6.5H15.5V9.5H8V6.5Z",
    fill: "#FE624D",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12.5H15.5V15.5H8V12.5Z",
    fill: "#FE624D",
    stroke: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4018_3774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4018_3774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeiqiang);
export default __webpack_public_path__ + "static/media/weiqiang.5e72aea834ad4ccfb6afa84812d07fa5.svg";
export { ForwardRef as ReactComponent };